module.exports = __webpack_public_path__ + "media/images/bubble-img-service-intro-answer-bottom-7faf74ebd336816c6040aab3c739b0c4.png";